/*-----------------------------------------------------------
//  Name: Apex.Core controllers
//  Description: All Controllers, Proxy Scripts, Handlers
//  Default WS Caching: 2hrs
//  Author: Amal Susainathan
//  Updated Date: 02/09/2021
//  Copyright: Microsoft Corporation, 2021
// -------------------------------------------------------*/

//----------------------Begin - jQuery Extension function to support the backward compatibility -------------------------//
(function (jQuery, window, undefined) {
    // See http://bugs.jquery.com/ticket/13335
    // "use strict";
    jQuery.uaMatch = function (ua) {
        ua = ua.toLowerCase();

        var match = /(chrome)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];

        return {
            browser: match[1] || "",
            version: match[2] || "0"
        };
    };

    // Don't clobber any existing jQuery.browser in case it's different
    if (!jQuery.browser) {
        var matched = jQuery.uaMatch(navigator.userAgent);
        var browser = {};

        if (matched.browser) {
            browser[matched.browser] = true;
            browser.version = matched.version;
        }

        // Chrome is Webkit, but Webkit is also Safari.
        if (browser.chrome) {
            browser.webkit = true;
        } else if (browser.webkit) {
            browser.safari = true;
        }

        jQuery.browser = browser;
    }

})(jQuery, window);
//----------------------End - jQuery Extension function to support the backward compatibility ----------------------------//

/*-----------------------------------------------------------
//      Apex GLOBAL VARIABLES
// -------------------------------------------------------*/
window.apex_glb = {
    EndPoint: '',
    SourceEndPoint: '',
    Project: '',
    ProjectId: '',
    ProjectAlias: '',
    Market: '',
    SupportMarket: '',
    SupportOptions: null,
    Language: '',
    ApexWinName: "_apexPlatformHelp",
    LocStrings: null,
    ViewConfig: null,
    Suggestions: null,
    Tours: null,
    EmbeddedHelp: false,
    Query: null,
    Success: null,
    Failure: null,
    Refresh: false,
    Authorize: false,
    Initialized: false,
    APIController: "apexv2api",
    CurrentView: "",
    onRailViewClose: function() {},
    onRailViewOpen: function() {},
    onPopupOpen: function() {},
    onPopupClose: function() {},
};

/*-----------------------------------------------------------
//      Apex Platform Controller
// -------------------------------------------------------*/
window.ApexPlatform = (function () {
    var myself = this;

    var isApexPlatformEnabled = function (platform) {
        try {
            var enable = $.trim($("input#apexPlatformEntries").attr(platform));
            if ((enable != undefined) && (enable != null)) {
                return (enable.toLowerCase() == "true");
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    };

    //this will be called from Ads APPs call back
    var adsInit = function () {
        var helpContainerId = 'apexHelpContainer';
        try {
            var embeddedClientElementClass = window.apex_glb.ViewConfig.RailView.embeddedClientElementClass;
            if (embeddedClientElementClass != undefined && embeddedClientElementClass != null && embeddedClientElementClass != '') {
                helpContainerId = embeddedClientElementClass;
            }
        } catch (ex) { }

        if (window.console && window.console.log)
            window.console.log("Popup - Load was performed.");
        $.fn.CreatePopup({
            project: window.apex_glb.Project,
            language: window.apex_glb.Language,
            helpUrl: window.apex_glb.EndPoint,
            SupportMarket: window.apex_glb.SupportMarket,
            Authorize: window.apex_glb.Authorize
        });

        if (window.console && window.console.log)
            window.console.log("AB - Load was performed.");
        //debugger;
        $.fn.CreateAnswerBar({
            Product: window.apex_glb.Project,
            Project: window.apex_glb.Project,
            Language: window.apex_glb.Language,
            HelpUrl: window.apex_glb.EndPoint,
            Enable: true,
            SupportMarket: window.apex_glb.SupportMarket,
            SupportOptions: window.apex_glb.SupportOptions,
            InitController: true,
            HelpContainerId: helpContainerId
        });
    };

    var apexTrapFocus = function (first, last) {
        if (first === null || last === null) {
            return
        }
        
        if (first.length == 1 && last.length == 1) {
            $(first).off('keydown');
            $(first).on('keydown', function (e) {
                var keyCode = e.keyCode || e.which;
                // Shift + Tab event
                if (keyCode == 9 && e.shiftKey) {
                    if (e.preventDefault) { e.preventDefault(); }
                    $(last).focus();
                }
            });

            $(last).off('keydown');
            $(last).on('keydown', function (e) {
                var keyCode = e.keyCode || e.which;
                // Tab event
                if (keyCode == 9 && !e.shiftKey) {
                    if (e.preventDefault) { e.preventDefault(); }
                    $(first).focus();
                }
            });
        }
    };

    var loadApexPopupFrameworks = function () {

        //create answer bar
        var apiUrl = '';
        var combineBothFramework = false;
        try {
            var enableEmbeddedHelp = window.apex_glb.ViewConfig.RailView.enableEmbeddedHelp;
            if (enableEmbeddedHelp != undefined && enableEmbeddedHelp != null && enableEmbeddedHelp == 'true') {
                if (isApexPlatformEnabled('initPopup')) {
                    combineBothFramework = true;
                }
            }
            if (combineBothFramework) {
                if (apex_glb.SourceEndPoint == '' || apex_glb.SourceEndPoint == apex_glb.EndPoint) {
                    window.apex_glb.SourceEndPoint = window.apex_glb.EndPoint;
                    apiUrl = "/Resources/content/scripts/apex.embed.v3.min.js?v=3.2.1.25";
                }
                else {
                    apiUrl = "apex.embed.v3.min.js?v=3.2.1.25";
                }
            }
        } catch (ex) { }
        if (apiUrl !== '') {
            window.apex_glb.EmbeddedHelp = true;
            if (typeof config != "undefined" && typeof config.getScriptForAds == "function") {
                config.getScriptForAds("", window.ApexPlatform.AdsInit);
            }
            else {
                $.getScript(window.apex_glb.SourceEndPoint + apiUrl, function (data, textStatus, jqxhr) {
                    adsInit();
                });
            }
        }
        else {
            bindPlatformEvents();
        }
        return combineBothFramework;
    };

    var loadOtherFrameworks = function () {
        window.console.log("Loading Apex Platform Frameworks");

        if (loadApexPopupFrameworks()) return;

        if (isApexPlatformEnabled('initPopup') && typeof window.popup_glb == 'undefined') {
            //create popup
            $.getScript(window.apex_glb.EndPoint + "/Resources/content/scripts/popupscript.apex.min.js?v=0.2.1.11", function (data, textStatus, jqxhr) {
                if (window.console && window.console.log)
                    window.console.log("Popup - Load was performed.");
                $.fn.CreatePopup({
                    project: window.apex_glb.Project,
                    language: window.apex_glb.Language,
                    helpUrl: window.apex_glb.EndPoint,
                    SupportMarket: window.apex_glb.SupportMarket,
                    Authorize: window.apex_glb.Authorize
                });
            });
        };

        if (isApexPlatformEnabled('initAnswerBar') && typeof window.ab_glb == 'undefined') {
            //create answer bar
            $.getScript(window.apex_glb.EndPoint + "/Resources/content/scripts/railhelpcontroller.apex.min.js?v=0.2.1.11", function (data, textStatus, jqxhr) {
                if (window.console && window.console.log)
                    window.console.log("AB - Load was performed.");
                //debugger;
                $.fn.CreateAnswerBar({
                    Product: window.apex_glb.Project,
                    Project: window.apex_glb.Project,
                    Language: window.apex_glb.Language,
                    HelpUrl: window.apex_glb.EndPoint,
                    Enable: true,
                    SupportMarket: window.apex_glb.SupportMarket,
                    InitController: true
                });
            });
            //bind Events
            bindPlatformEvents();
        }
        else {
            //create answer bar
            var apiUrl = '';
            var helpContainerId = '';
            try {
                var enableEmbeddedHelp = window.apex_glb.ViewConfig.RailView.enableEmbeddedHelp;
                var embeddedClientElementClass = window.apex_glb.ViewConfig.RailView.embeddedClientElementClass;

                if (enableEmbeddedHelp != undefined && enableEmbeddedHelp != null && enableEmbeddedHelp == 'true') {
                    apiUrl = "/Resources/content/scripts/apex.embed.min.js?v=0.2.1.19";
                    if (embeddedClientElementClass != undefined && embeddedClientElementClass != null && embeddedClientElementClass != '') {
                        helpContainerId = embeddedClientElementClass;
                    }
                    else {
                        helpContainerId = 'apexHelpContainer';
                    }
                }
            } catch (ex) { }
            if (apiUrl !== '') {
                window.apex_glb.EmbeddedHelp = true;
                $.getScript(window.apex_glb.EndPoint + apiUrl, function (data, textStatus, jqxhr) {
                    if (window.console && window.console.log)
                        window.console.log("AB - Load was performed.");
                    //debugger;
                    $.fn.CreateAnswerBar({
                        Product: window.apex_glb.Project,
                        Project: window.apex_glb.Project,
                        Language: window.apex_glb.Language,
                        HelpUrl: window.apex_glb.EndPoint,
                        Enable: true,
                        SupportMarket: window.apex_glb.SupportMarket,
                        SupportOptions: window.apex_glb.SupportOptions,
                        InitController: true,
                        HelpContainerId: helpContainerId
                    });
                });
            }
            else {
                bindPlatformEvents();
            }

        };

        if (isApexPlatformEnabled('initHelpCoach')) {
            //create help coach

        };
    };

    var handlePlatformGlobalsSuccessForInit = function (data) {

        //debugger;
        var returnval = true;
        if (window.apex_glb.Authorize == true) {
            data = $.parseJSON(data);
        }
        if (data) {
            window.apex_glb.ProjectId = data.ProjectId;
            window.apex_glb.Language = data.Language;
            window.apex_glb.ProjectAlias = data.ProjectAlias;
            window.apex_glb.LocStrings = data.LocStrings;
            window.apex_glb.ViewConfig = data.ViewConfig;
            window.apex_glb.Suggestions = data.Suggestions;
            window.apex_glb.Tours = data.Tours;
            try {
                $.each(data.ViewConfig.RailView.ViewItem, function (index, value) {
                    if (value.Type.toUpperCase() == "HELP") {
                        window.apex_glb.Query = value.Query;
                    }
                });
                loadOtherFrameworks();
            }
            catch (e) { returnval = false; }
        }
        if (returnval) {
            if (typeof window.apex_glb.Success === "function") {
                status = { "components": [{ "type": "ApexPlatform", "status": "success", "description": "Apex Platform has been loaded successfully" }] };
                window.apex_glb.Success(status);
            }
        } else {
            if (typeof window.apex_glb.Failure === "function") {
                status = { "components": [{ "type": "ApexPlatform", "status": "failed", "description": "Unable to load the data.  Please check the configuration" }] };
                window.apex_glb.Failure(status);
            }
        }
    };

    var handlePlatformGlobalsSuccessForRefresh = function (data) {

        //debugger;
        if (window.apex_glb.Authorize == true) {
            data = $.parseJSON(data);
        }
        if (data) {
            window.apex_glb.ProjectId = data.ProjectId;
            window.apex_glb.Language = data.Language;
            window.apex_glb.LocStrings = data.LocStrings;
            window.apex_glb.ViewConfig = data.ViewConfig;
            window.apex_glb.Suggestions = data.Suggestions;
            window.apex_glb.Tours = data.Tours;
            try {
                $.each(data.ViewConfig.RailView.ViewItem, function (index, value) {
                    if (value.Type.toUpperCase() == "HELP") {
                        window.apex_glb.Query = value.Query;
                    }
                });
            } catch (ex) { }
            window.console.log("AB - global refresh => " + window.apex_glb.Refresh + ' -- ' + typeof RailHelpController);
            if (typeof RailHelpController !== 'undefined') {
                if (typeof RailHelpController.Refresh === 'function') {
                    RailHelpController.Refresh();
                }
            }
        }
    };

    var handlePlatformGlobalsFailure = function (jqXHR, textStatus, errorThrown) {
        if (typeof window.apex_glb.Failure === "function") {
            window.apex_glb.Failure(jqXHR, textStatus, errorThrown);
        }
    };

    //performs GetContent
    var getPlatformGlobals = function (init) {
        //Hack for param
        var viewId = '';
        if (window.apex_glb.CurrentView == "" || window.apex_glb.CurrentView == null) {
            viewId = $('[RailViewID]')[0] == undefined ? getViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
        }
        else {
            viewId = window.apex_glb.CurrentView;
        }
        $('#apexPlatformEntries').attr('viewName', viewId);
        var input = {
            'project': window.apex_glb.Project,
            'language': window.apex_glb.Market,
            'view': viewId
        };

        if (window.apex_glb.APIController == null || window.apex_glb.APIController == "" || window.apex_glb.APIController == undefined) {
            window.apex_glb.APIController = "apexapi";
        }
        //var url = window.apex_glb.EndPoint + "/api/apexapi/ApexConfig";
        var url = window.apex_glb.Authorize == true ? "/ApexHelp/HelpConfig" : window.apex_glb.EndPoint + "/api/" + window.apex_glb.APIController + "/ApexConfig";
        $.ajax({
            url: url,
            data: input,
            //method: "POST",
            contentType: 'application/json',
            crossDomain: true,
            // dataType: 'jsonp',
            cache: false,
            success: init ? handlePlatformGlobalsSuccessForInit : handlePlatformGlobalsSuccessForRefresh,
            error: handlePlatformGlobalsFailure,
            timeout: 60000
        });
    };

    var isNumber = function (n) {
        return parseFloat(n) == n;
    };

    var getViewName = function () {
        var viewname = "Default";
        var lochref = location.href;
        var indexHash = lochref.indexOf('#', 0);
        var pathname = location.pathname;
        if (indexHash >= 0) {
            var indexQn = lochref.indexOf('?', indexHash);
            pathname = lochref.substring(indexHash, indexQn);
        }

        var index = pathname.indexOf('.aspx', 0);
        var paths;
        var length;
        var minLength = 2;
        //MVC
        if (index < 0) {
            paths = pathname.split('/');
            length = paths.length;
            for (var i = length - 1; i > 0; i--) {
                if (isNumber(paths[i])) {
                    paths.splice(i, 1);
                }
            }
            length = paths.length;
        }
        else { //ASPX
            var aspxname = pathname.substr(0, index);
            paths = aspxname.split('/');
            length = paths.length;
            minLength = 1;
        }

        if (length > minLength) {
            if ($.trim(paths[length - 2]) != "") {
                viewname = paths[length - 2];
                if ($.trim(paths[length - 1]) != "") {
                    viewname = viewname + '_' + paths[length - 1];
                };
            } else if ($.trim(paths[length - 1]) != "") {
                viewname = paths[length - 1];
            };
        }
        else if (length > (minLength - 1)) {
            if ($.trim(paths[length - 1]) != "") {
                viewname = paths[length - 1];
            };
        }

        return viewname;
    };

    var linkHandler = function (elem) {
        //debugger;
        if (elem.stopPropagation) { elem.stopPropagation(); }
        try {
            if ($('#apexHelpContainer').length > 0) {
                if ($('.apex_platform_chrome').length <= 0) {
                    window.ApexPlatform.Init();
                }
                else {
                    window.ApexPlatform.Refresh();
                }
            }
        }
        catch (e) { };

        var query = $(elem.target).attr('Query');
        if (query == undefined || query == null) query = window.apex_glb.Query;
        var viewId = $('[RailViewID]')[0] == undefined ? getViewName() : $('[RailViewID]')[0].attributes['railviewid'].value;
        var targetUrl = window.apex_glb.EndPoint + '/#apex/' + window.apex_glb.ProjectAlias + '/' + window.apex_glb.Language + '/' + query + '/-1/' + window.apex_glb.SupportMarket + '/#ext:' + viewId;
        //window.open(targetUrl, window.apex_glb.ApexWinName);
        var winref = window.open(targetUrl, window.apex_glb.ApexWinName); //Force to open in new window
        if (winref != null && typeof winref == 'object') winref.focus(); //no hidden window
    };

    var bindPlatformEvents = function () {
        $(document).off('click', '.HelpTopic, .HelpTopic span, .HelpTopic div,.apexHelpLink');
        //$(document).on('click', '.apexHelpLink', linkHandler);
        document.addEventListener('click', function (e) {
            for (var target = e.target; target && target != this; target = target.parent) {
                try {
                    if (typeof target.matches == "function") {
                        if (target.matches('.HelpTopic, .HelpTopic span, .HelpTopic div,.apexHelpLink')) {
                            linkHandler.call(target, e);
                        }
                    }
                }
                catch (e) { };
            }

        }, true);
        //$(document).off('click', '.HelpTopic');
        //$(document).on('click', '.HelpTopic', linkHandler);

    };

    var init = function () {

        //Get Platform Gloabls
        window.apex_glb.CurrentView = "";
        getPlatformGlobals(true);

        //bind Events
        //if (window.apex_glb.EmbeddedHelp == false) {
        //     bindPlatformEvents();
        //}
    };

    var refresh = function (viewName) {

        if ($('#railhelp_bar').length > 0) {
            $('#railhelp_bar').remove();
            $('#railhelp_show').remove();
            $('#railhtml').html('');
        }
        if (window.apex_glb.Initialized == true) {
            if ((typeof (viewName) == "undefined") || (viewName == '') || (viewName == null)) {
                viewName = "";
            }
            window.apex_glb.CurrentView = viewName;
            window.apex_glb.Refresh = true;
            getPlatformGlobals(false);
        }
    };
    var autoSuggestionsList = function (term) {
        return $.fn.suggestionBox.showApexSuggestionsTerm(term);
    };

    return {

        /*Intialize Controller*/
        Init: init,
        Refresh: refresh,
        AdsInit: adsInit,
        ApexTrapFocus: apexTrapFocus,
        AutoSuggestions: autoSuggestionsList
    };
})();

/*------------ Apex Platform Plugin ----------------------*/
//
// create closure
//
(function ($) {
    //
    // plugin definition
    //
    $.fn.InitApexPlatform = function (options) {
        var thisElem = mainpulateRootElement(this);
        debug(this);
        // build main options before element iteration
        var opts = $.extend({}, $.fn.InitApexPlatform.defaults, options);
        // iterate and reformat each matched element
        return thisElem.each(function () {
            var $this = $(this);
            // build element specific options
            var o = $.meta ? $.extend({}, opts, $this.data()) : opts;

            $.fn.InitApexPlatform.format($this, o);
        });
    };

    var mainpulateRootElement = function (o) {
        var id = o.attr('id');
        var thisElem = o;
        if (id == undefined || id.toLowerCase() != 'apexPlatformEntries') {
            var elem = $("#apexPlatformEntries");
            if (elem.length != 0) {
                thisElem = elem;
            }
            else {
                var inputmarkup = '<INPUT id="apexPlatformEntries"  type="hidden"></INPUT>';
                $(inputmarkup).appendTo($('body')[0]);
                thisElem = $("#apexPlatformEntries");
            }
        }
        return thisElem;
    };

    //
    // private function for debugging
    //
    function debug($obj) {
        if (window.console && window.console.log)
            window.console.log('InitApexPlatform selection count: ' + $obj.length);
    };
    //
    // define and expose our format function
    //
    $.fn.InitApexPlatform.format = function (e, o) {
        var endPoint = o.EndPoint.replace('help.bingads', 'help.ads').replace('help.si.bingads', 'help.ads-int');
        var lastChar = endPoint.substring(endPoint.length - 1);
        if ((lastChar == '/') || (lastChar == '\\')) {
            endPoint = endPoint.substring(0, endPoint.length - 1);
        }
        $('#apexPlatformEntries').attr('endPoint', endPoint);
        $('#apexPlatformEntries').attr('project', o.Project);
        $('#apexPlatformEntries').attr('projectId', o.ProjectId);
        $('#apexPlatformEntries').attr('market', o.Market);
        $('#apexPlatformEntries').attr('language', o.Language);
        $('#apexPlatformEntries').attr('supportMarket', o.SupportMarket);
        $('#apexPlatformEntries').attr('initAnswerBar', o.InitAnswerBar);
        $('#apexPlatformEntries').attr('initPopup', o.InitPopup);
        $('#apexPlatformEntries').attr('authorize', o.Authorize);
        $('#apexPlatformEntries').attr('initHelpCoach', o.InitHelpCoach);
        $('#apexPlatformEntries').attr('initOnReady', o.InitOnReady);
        $('#apexPlatformEntries').attr('helpContainerId', o.HelpContainerId);
        $('#apexPlatformEntries').attr('viewName', '');
        $('#apexPlatformEntries').attr('sourceEndPoint', o.SourceEndPoint);

        window.apex_glb.Success = o.Success;
        window.apex_glb.Failure = o.Failure;

        window.apex_glb.EndPoint = endPoint;
        window.apex_glb.SourceEndPoint = o.SourceEndPoint;
        window.apex_glb.Project = o.Project;
        //window.apex_glb.Project = o.Authorize == true ? o.Project + '_secured' :  o.Project; //TODO:Remove after sand box //amal
        window.apex_glb.Market = o.Market;
        window.apex_glb.Language = o.Language;
        window.apex_glb.Refresh = false;
        window.apex_glb.Initialized = true;
        window.apex_glb.Authorize = o.Authorize;
        window.apex_glb.SupportMarket = o.SupportMarket == '' ? o.Market : o.SupportMarket;
        window.apex_glb.SupportOptions = o.SupportOptions;
        window.apex_glb.Success = o.Success;
        window.apex_glb.Failure = o.Failure;
        window.apex_glb.onRailViewClose = o.onRailViewClose;
        window.apex_glb.onRailViewOpen = o.onRailViewOpen;
        window.apex_glb.onPopupOpen = o.onPopupOpen;
        window.apex_glb.onPopupClose = o.onPopupClose;
        if ((o.InitOnReady == false) || (o.InitOnReady == "false")) {
            if (window.console && window.console.log) window.console.log('InitApexPlatform - InitOnReady = false');
            window.ApexPlatform.Init();
        }
        window.apex_glb.renderApexHelpSuggestions = o.renderApexHelpSuggestions;
        window.apex_glb.renderSearchInputIcon = o.renderSearchInputIcon;
    };

    //
    // plugin defaults
    //
    $.fn.InitApexPlatform.defaults = {
        EndPoint: "http://help.ads-int.microsoft.com",
        SourceEndPoint: "",
        Project: 'none',
        ProjectId: -1,
        Market: 'en-US',
        Language: '',
        SupportMarket: '',
        SupportOptions: null,
        InitAnswerBar: false,
        InitPopup: false,
        InitHelpCoach: false,
        InitOnReady: true,
        HelpContainerId: '',
        Authorize: false,
        Success: null,
        Failure: null
    };
    //
    // end of closure
    //
})(jQuery);

/*  Auto Suggesions Box Plug-in Begin  - Begin*/
(function ($) {

    $.fn.suggestionBox = function (options) {

        var $searchBox = this;

        var settings = $.extend({
            // default settings.
            topOffset: 0,
            leftOffset: 0,
            widthAdjustment: 0,
            delay: 400, // in ms
            heading: 'Suggestions',
            results: 8,
            menuWidth: 'auto',
            showNoSuggestionsMessage: false,
            noSuggestionsMessage: 'No Suggestions Found',
            filter: false,
            filterPattern: "({INPUT})",
            ajaxError: function (e) {
                console.log(e);
            },
            ajaxSuccess: function (data) {
            },
            enterKeyAction: function () {
                goToSelection();
            },
            paramName: 'search'
        },
            options);

        $.fn.suggestionBox.showApexSuggestions = function () {
            active = true;
            showSuggestions();
        };

        $.fn.suggestionBox.showApexSuggestionsTerm = function (term) {
            active = true;
            return showSuggestions(term);
        };

        // Inject the suggestion box into the body of the web page
        $('body').append('<div id="apex-suggestion-box"></div><div id="announce-suggestions" class="screen-reader-only" aria-live="assertive"></div>');

        // Turn off autocomplete
        $searchBox.attr('autocomplete', 'off');

        var $suggestionBox = $('#apex-suggestion-box');
        setSuggestionBoxPosition();

        // Constants for key values
        var ENTER_KEY = 13;
        var UP_ARROW_KEY = 38;
        var DOWN_ARROW_KEY = 40;
        var ESCAPE_KEY = 27;

        // Default values for selected list item
        var selectedLi = -1;
        var selectedHref = '#';

        // Is the mouse hovering over the suggestion box?
        var mouseHover = false;
        // Timer for only making ajax calls when the user stops typing
        var timer = null;
        // Did we get any suggestions?
        var matches = false;
        // Is the search box active (does it have focus)
        var active = false;
        // create a blank object for our request
        var request = {};
        var jsonData = {};

        // The value of the input when ajax was called
        var ajaxCalledVal;

        //$suggestionBox.die('mousemove');
        //$suggestionBox.die('mouseout');
        //$suggestionBox.die('click');
        try {
            $suggestionBox.on({
                mousemove: function (e) {
                    if (e.target.nodeName === 'A') {
                        //unselect(selectedLi);
                        selectedLi = getSelectionMouseIsOver(e);
                        //select(selectedLi);
                    }
                    mouseHover = true;
                },
                mouseout: function (e) {
                    if (e.target.nodeName === 'A') {
                        //unselect(selectedLi);
                        resetSelection();
                    }
                    mouseHover = false;
                },
                mouseenter: function(e) {
                    mouseHover = true;
                },
            });
        } catch (ex) { }

        //$searchBox.die('live');
        //$searchBox.die('focus');
        //$searchBox.die('keyup');
        //$searchBox.die('keydown');
        //$searchBox.die('paste');
        try {
            $searchBox.on({
                mouseenter: function() {
                    mouseHover = true;
                },
                mouseout: function() {
                    mouseHover = false;
                },
                blur: function () {
                    active = false;
                    // Only close the menu if we are not clicking a link
                    if (!mouseHover) {
                        hideSuggestionBox();
                    }
                },
                focus: function () {
                    active = true;
                    /*if ($(this).val()) {
                        showSuggestions(jsonData);
                    }*/
                    mouseHover = true;
                    if (typeof window.apex_glb.renderApexHelpSuggestions === 'function' && settings.filter) {
                        showSuggestions();
                    }
                },
                keyup: function (e) {

                    // Ignore the navigation keys. We don't want to fire ajax calls when navigating
                    if (e.which !== UP_ARROW_KEY && e.which !== DOWN_ARROW_KEY && e.which !== ESCAPE_KEY && e.which !== ENTER_KEY) {
                        if (settings.url) {
                            resetSelection();

                            if (timer) {
                                clearTimeout(timer);
                            }
                        }

                        if (settings.url) {
                            // set the request to be sent sent as the data parameter
                            request[settings.paramName] = $searchBox.val();
                            timer = setTimeout(function () {
                                getSuggestions(settings.url)
                            }, settings.delay);
                        }
                        if (settings.filter) {
                            showSuggestions();
                        }
                    }
                    else {
                        if (e.which == ENTER_KEY) {
                            hideSuggestionBox();
                        }
                    }
                },
                keydown: function (e) {
                    if ($suggestionBox.css('display') !== 'none') {
                        if (e.which == DOWN_ARROW_KEY) {
                            e.preventDefault();
                            moveDown();
                        }
                        if (e.which == UP_ARROW_KEY) {
                            e.preventDefault();
                            moveUp();
                        }
                        if (e.which === ENTER_KEY && selectedLi > -1) {
                            e.preventDefault();
                            settings.enterKeyAction();
                        }
                        if (e.which == ESCAPE_KEY) {
                            e.preventDefault();
                            hideSuggestionBox();
                        }
                    }
                },
                paste: function () {
                    // Simulate keyup after 200ms otherwise the value of the search box will not be available
                    setTimeout(function () {
                        $searchBox.keyup();
                    }, 200);
                }
            });
        } catch (ex) { }

        $(document.body).on('click', () => {
            if (!mouseHover) {
                $suggestionBox.css('display', 'none');
            }
        });

        $('#apexContentMain').on('click', () => {
            mouseHover = false;
        });

        // Reset the position of the suggestion box if the window is re-sized
        $(window).resize(function () {
            setSuggestionBoxPosition();
        });

        // Reset the position of the suggestion box if the window is scrolled
        $(window).scroll(function () {
            setSuggestionBoxPosition();
        });

        /**
         * Selects the suggestion at the given position
         * @param position
         */
        //function select(position) {
        //    selectedHref = $suggestionBox.find("li:eq(" + position + ") a").attr('href');
        //    //$suggestionBox.find("li:eq(" + position + ")").addClass('selected');
        //}

        ///**
        // * Unselects the suggestion at the given position
        // * @param position
        // */
        //function unselect(position) {
        //    $suggestionBox.find("li:eq(" + position + ")").removeClass('selected');
        //}

        /**
         * Resets any selected suggestions
         */
        function resetSelection() {
            selectedHref = '#';
            selectedLi = -1;
            // remove all selected on reset
            $suggestionBox.find('li').removeClass('selected');
        }

        /**
         * Moves the selection down to the next suggestion
         */
        function moveDown() {
            var listSize = $suggestionBox.find('li').length;
            if (selectedLi === (listSize - 1)) {
                //unselect(selectedLi);
                resetSelection();
            } else {
                //unselect(selectedLi);
                selectedLi++;
                //select(selectedLi);
            }
        }

        /**
         * Moves the selection up to the previous suggestions
         */
        function moveUp() {
            if (selectedLi > 0) {
                //unselect(selectedLi);
                selectedLi--;
                //select(selectedLi);
            } else if (selectedLi == -1) {
                //unselect(selectedLi);
                selectedLi = $suggestionBox.find('li').length - 1;
                //select(selectedLi);
            } else {
                //unselect(0);
                resetSelection();
            }
        }

        /**
         * Redirects the user to the selected suggestion location
         */
        function goToSelection() {
            $suggestionBox.css('display', 'none');
            window.location = selectedHref;
        }

        /**
         * Makes an ajax call to the given url
         * @param url
         */
        function getSuggestions(url) {
            ajaxCalledVal = $searchBox.val();
            $.ajax({
                url: url,
                data: request,
                dataType: 'json',
                success: function (data) {

                    var selectionHasChanged = true;
                    var currentLi = selectedLi;

                    if (jsonData.results && data.results) {
                        selectionHasChanged = (JSON.stringify(jsonData.results[selectedLi]) !== JSON.stringify(data.results[selectedLi]))
                    }

                    setJsonData(data);
                    showSuggestions();

                    // Keep selection if no new information has been entered since ajax was called and the selection is the same.
                    // This prevents the flick back effect when menu has the same data but the ajax hasn't finished.
                    if (currentLi > -1 && ($searchBox.val() === ajaxCalledVal) && !selectionHasChanged) {
                        selectedLi = currentLi;
                        //select(selectedLi);
                    }

                    settings.ajaxSuccess(data);
                },
                error: function (e) {
                    settings.ajaxError(e);
                }
            });
        }

        /**
         * Returns the index of the list item the mouse is currently hovering over
         * @param e
         * @returns {Number}
         */
        function getSelectionMouseIsOver(e) {
            var $parentLi = $(e.target).parent('li');
            return $parentLi.parent().children().index($parentLi);
        }

        /**
         * Sets the position of the suggestion box
         */
        function setSuggestionBoxPosition() {
            var borders = getCssValue($searchBox, 'border-bottom-width') + getCssValue($searchBox, 'border-top-width');
            var padding = getCssValue($searchBox, 'padding-bottom') + getCssValue($searchBox, 'padding-top');

            $suggestionBox.css({
                'position': 'absolute',
                'left': ($searchBox.offset().left) + settings.leftOffset,
                'top': ($searchBox.offset().top) + ($searchBox.height() + borders + padding + settings.topOffset)
            });
        }

        /**
         * Gets the css integer value for the given element.
         * @param element
         * @param name
         * @returns {Number}
         */
        function getCssValue(element, name) {
            if (element.css(name) !== undefined) {
                return parseInt(element.css(name).replace('px', ''));
            }
            else {
                return 0;
            }
        }

        /**
         * Hides the suggestion box
         */
        function hideSuggestionBox() {
            $suggestionBox.hide();
            resetSelection();
            $('#searchquery').attr('aria-expanded', 'false');
            $("#announce-suggestions").html("No suggestions available. Suggestion list hidden.");
        }

        /**
         * Displays the apex-suggestion-box
         */
        function showSuggestionBox() {
           $suggestionBox.show();
           $('#searchquery').attr('aria-expanded', 'true');
        }

        /**
         * Sets the width of the suggestion box
         */
        function setSuggestionBoxWidth() {
            var searchBoxWidth = getSearchBoxWidth() + settings.widthAdjustment;
            if (settings.menuWidth == 'auto') {
                $suggestionBox.css({
                    'min-width': searchBoxWidth
                });
            } else if (settings.menuWidth == 'constrain') {
                $suggestionBox.css({
                    'width': searchBoxWidth
                });
            }
        }

        /**
         * Returns the width of the search box
         * @returns {number}
         */
        function getSearchBoxWidth() {
            const $searchIcon = $('.apex_search_icon');
            return (
                $searchBox.width() + $searchIcon.width() +
                getCssValue($searchBox, 'border-left-width') +
                getCssValue($searchBox, 'border-right-width') +
                getCssValue($searchBox, 'padding-left') +
                getCssValue($searchBox, 'padding-right')
            );
        }

        function createSuggestionsList(data) {
            if (data.results == null) {
                return '';
            }

            //var $suggestions = '<div id="apex-suggestion-header">' + settings.heading + '</div> ' + '<ul id="apex-suggestion-box-list
            var $suggestions = '<ul id="apex-suggestion-box-list" role="listbox">';

            $.each(data.results, function (key, value) {
                if (value.suggestion && value.url) {
                    matches = true;
                    var attr = "";
                    if (value.attr) {
                        $.each(value.attr, function (key, value) {
                            var keys = Object.keys(value);
                            for (var i = 0; i < keys.length; i++) {
                                attr += keys[i] + '="' + value[keys[i]] + '" '
                            }
                        });
                    }

                    if (value.video == '') {
                        $suggestions += '<li role="listitem"><span class="apex-topic"/><span><a href="#" id="suggestion-' + value.url + '" class="apex-suggestion-item" tabindex="0" role="option" secretkey="' + value.url + '" topic="" ' + attr + '>' + value.suggestion + '</a></li>';
                        //$suggestions += '<li><span class="apex-topic"/><span><a href="/#apex/' + apexMainViewModel.projectId() + '/' + apexMainViewModel.language() + '/' + value.url + '/0" ' + attr + '>' + value.suggestion + '</a></span></li>';
                    }
                    else {
                        var vids = value.video.split("~");
                        if ((vids.length == 2) && (vids[1] !== undefined)) {
                            $suggestions += '<li role="listitem"><span class="apex-video" videoid="' + vids[0] + '" op_videoid="' + vids[1] + '"/><span class="apex-video-text"><a href="#"  id="suggestion-' + value.url + '" class="apex-suggestion-item" tabindex="0" role="option" videoid="' + vids[0] + '" op_videoid="' + vids[1] + '" ' + attr + '>' + value.suggestion + '</a></span></li>';
                        }
                        else {
                            $suggestions += '<li role="listitem"><span class="apex-video" videoid="' + value.video + '"/><span class="apex-video-text"><a  id="suggestion-' + value.url + '" class="apex-suggestion-item" tabindex="0" role="option" videoid="' + value.video + '" ' + attr + '>' + value.suggestion + '</a></span></li>';
                        }
                    }
                    //$suggestions += '<li><a href="#" secretkey="' + value.url + '" topic="" ' + attr + '>' + value.suggestion + '</a></li>';
                } else {
                    return false;
                }

                // break when maximum results have been found
                if (key === (settings.results - 1)) {
                    return false;
                }
            });
            $suggestions += '</ul>';

            return $suggestions;
        }

        /**
         * Shows the apex-suggestion-box suggestions if they are available based on the data passed in
         */
        function showSuggestions(term) {
            //mainly dynamic search
            if (term != undefined && term != null) {
                var data = (settings.filter) ? filterResults(term) : jsonData;
                if (data) {
                    return data.results;
                }
                else {
                    return data;
                }
            }
            else {
                setSuggestionBoxPosition();
                resetSelection();

                matches = false;

                var data = (settings.filter) ? filterResults($searchBox.val()) : jsonData;
                if (data) {
                    if (data.results) {
                        var $suggestions = createSuggestionsList(data);
                    }
                }

                // Check for focus before showing suggestion box. User could have clicked outside before request finished.
                if (active) {
                    if (typeof window.apex_glb.renderApexHelpSuggestions === 'function') {
                        const result = window.apex_glb.renderApexHelpSuggestions(data, $suggestionBox.get(0), createSuggestionsList, hideSuggestionBox);
                        if (result && result.showSuggestions) {
                            setSuggestionBoxWidth();
                            showSuggestionBox();
                        } else {
                            hideSuggestionBox();
                        }
                    } else if (matches) {
                        $suggestionBox.html($suggestions);
                        setSuggestionBoxWidth();
                        showSuggestionBox();
                        var suggestionAmount = $("#apex-suggestion-box-list li").length + ' suggestions found, use tab to review';
                        $("#announce-suggestions").html(suggestionAmount);
                    } else if (settings.showNoSuggestionsMessage && $searchBox.val().length > 0) {
                        setSuggestionBoxWidth();
                        showSuggestionBox();
                        $suggestionBox.html('<div id="no-suggestions">' + settings.noSuggestionsMessage + '</div>');
                    } else {
                        hideSuggestionBox();
                    }
                    // ESC key close suggestions
                    //$(document).keyup(function (e) {
                    //    if (e.preventDefault) { e.preventDefault(); }
                    //    if (e.which === 27) {
                    //        $(".apex_search_area input#searchquery").focus();
                    //        $("#apex-suggestion-box").css("display", "none");
                    //        $(".apex_search_area input#searchquery").attr("aria-activedescendant", "");
                    //    }
                    //});

                    var firstElem = $("#apex-suggestion-box-list li:first a");
                    var lastElem = $("#apex-suggestion-box-list li:last a");
                    window.ApexPlatform.ApexTrapFocus(firstElem, lastElem);

                    //Set aria-activedescendant to suggestion id
                    $("#apex-suggestion-box-list li a").focus(function (e) {
                        $('.apex_search_area input#searchquery').attr('aria-activedescendant', $(this).attr('id'));
                    });

                    // Hide Suggestions on blur
                    $("#apex-suggestion-box-list li a").blur(function (e) {
                        setTimeout(function () {
                            if (document.activeElement.className != e.target.className) {
                                hideSuggestionBox();
                                $(".apex_search_area input#searchquery").attr("aria-activedescendant", "");
                            }
                        }, 1);
                    });

                    firstElem = $("#apex-suggestion-box-list li:first a");
                    lastElem = $("#apex-suggestion-box-list li:last a");
                    window.ApexPlatform.ApexTrapFocus(firstElem, lastElem);
                } else {
                    hideSuggestionBox();
                }
            }
        }

        /**
         * Sets the current JSON data ready for display
         * @param json
         */
        function setJsonData(json) {
            if (json) {
                jsonData = (json instanceof Object) ? json : $.parseJSON(json);
            } else {
                jsonData = {};
            }
        }

        /**
         * Loads JSON from the given url
         * @param url
         */
        function loadJson(url) {
            $.ajax({
                url: url,
                dataType: 'json',
                success: function (data) {
                    setJsonData(data);
                },
                error: function (e) {
                    console.log(e);
                }
            });
        }

        /**
         * Filters the JSON based on the user input
         * @param value
         * @returns {Object}
         */
        function filterResults(value) {
            var data;

            // escape regex chars
            value = value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            filterPattern = settings.filterPattern.replace("{INPUT}", value);
            if (!value) {
                return {};
            }
            if (jsonData) {
                if (jsonData.results) {

                    var regex = new RegExp(filterPattern, "i");

                    data = $.grep(jsonData.results, function (name) {
                        return regex.test(name.suggestion);
                    });
                }
            }

            if (settings.sort) {
                data.sort(settings.sort);
            }

            var json = JSON.stringify({ "results": data });

            return $.parseJSON(json);
        }

        // returned methods
        return {
            loadSuggestions: function (url) {
                loadJson(url);
                return this;
            },
            addSuggestions: function (json) {
                setJsonData(json);
                return this;
            },
            showSuggestions: function () {
                showSuggestionBox();
                return this;
            }
        };

    };
}(jQuery));
/*  Auto Suggesions Box Plug-in Begin */

/*----------- Page OnLoad Methods ---------------------*/
$(document).ready(function () {

    var initReady = $('#apexPlatformEntries').attr('initOnReady');
    if (initReady == 'true' || initReady == true) {
        if (window.console && window.console.log) window.console.log('InitApexPlatform - InitOnReady - True');
        window.ApexPlatform.Init();
    }

});

